// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html




// AbilityIntranet.Data.Intranet.AuthNetHostedProfilePageModeType
export enum AuthNetHostedProfilePageModeType {
    
    Manage = 0,
    AddPayment = 1,
    EditPayment = 2
}
